import { render, staticRenderFns } from "./PhotovoltaicMain.vue?vue&type=template&id=86f94e4c&scoped=true"
import script from "./PhotovoltaicMain.vue?vue&type=script&lang=js"
export * from "./PhotovoltaicMain.vue?vue&type=script&lang=js"
import style0 from "./PhotovoltaicMain.vue?vue&type=style&index=0&id=86f94e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f94e4c",
  null
  
)

export default component.exports